import { getCareWorkArea } from '@vivaporta/work-areas';
// Complete class names let Tailwind bundle these icons into the production stylesheet.
const industryIcons: Record<string, string> = {
  gastronomie:'icon-[material-symbols--restaurant-rounded]',
  baecker:'icon-[material-symbols--bakery-dining]',
  metzger:'icon-[material-symbols--set-meal-outline-rounded]',
  frischetheke:'icon-[material-symbols--storefront-outline-rounded]',
  pflege: 'icon-[material-symbols--medical-services-outline-rounded]',
  einzelhandel: 'icon-[material-symbols--storefront-outline-rounded]',
  handwerk: 'icon-[material-symbols--handyman-outline]',
  elektriker: 'icon-[material-symbols--electrical-services-rounded]',
  bauwesen: 'icon-[material-symbols--engineering-outline-rounded]',
  schweisser: 'icon-[material-symbols--local-fire-department-outline-rounded]',
  cnc: 'icon-[material-symbols--precision-manufacturing-outline-rounded]',
  shk: 'icon-[material-symbols--plumbing]',
  'lkw-fahrer': 'icon-[material-symbols--local-shipping-outline-rounded]',
};

export const navigationIndustryIcon = (href: string): string => {
  const key = href.match(/(?:\/branchen\/|#)([^/?#]+)/u)?.[1];
  return getCareWorkArea(key)?.icon || (key && industryIcons[key]) || 'icon-[material-symbols--work-outline]';
};
